<template>
  <sfs-form-modal
    :id="modalId"
    :title="`Edit ${documentType} #${value.number}`"
    size="lg"
    @on-hide="resetFormData"
  >
    <compliance-document-form
      v-bind="value"
      @on-submit="update"
      @on-save="onUpdate"
      @on-cancel="closeModal"
      :new-form="false"
      :reminder-frequency-options="reminderFrequencyOptions"
      :category-options="categoryOptions"
      :key="formKey"
    />
  </sfs-form-modal>
</template>

<script>
import ComplianceDocumentForm from './Form.vue';
import formModalMixin from '@/mixins/formModalMixin';

export default {
  name: 'ComplianceDocumentEditModal',
  mixins: [formModalMixin],
  components: {
    ComplianceDocumentForm,
  },
  props: {
    value: Object,
  },
  data() {
    return {
      reminderFrequencyOptions: [],
      categoryOptions: [],
      modalId: 'compliance-document-edit-modal',
    };
  },
  mounted() {
    this.getReminderFrequencyOptions();
    this.getCategoryOptions();
  },
  methods: {
    getReminderFrequencyOptions() {
      this.$complianceDocumentsAPI.getReminderFrequencyOptions().then((response) => {
        this.reminderFrequencyOptions = response.data.reminder_frequency_options.map((option) => {
          return { label: option[0], value: option[1] };
        });
      });
    },
    getCategoryOptions() {
      this.$store.cache.dispatch('getComplianceDocumentCategories').then((options) => {
        this.categoryOptions = options.map((option) => {
          return { label: option[0], value: option[1] };
        });
      });
    },
    update(data, handleUpdate) {
      handleUpdate(this.$complianceDocumentsAPI.update(this.value.id, data));
    },
    onUpdate(complianceDocument) {
      this.closeModal();
      this.$emit('input', complianceDocument);
    },
  },
  computed: {
    documentType() {
      return this.$options.filters.capitalizeFormat(this.$options.filters.humanizedFormat(this.value.document_type));
    },
  },
};
</script>
